/**
 * Exposes the element's full text as a native `title` only while it is
 * clipped, so a value that fits gets no redundant tooltip. Bind it to
 * `onMouseEnter`: a native title only surfaces on hover, so checking there is
 * early enough. Pass `label` when the title must differ from the text.
 */
export function showTitleOnlyWhenTruncated(
  event: { readonly currentTarget: HTMLElement },
  label = event.currentTarget.textContent,
): void {
  const element = event.currentTarget;

  if (element.scrollWidth > element.clientWidth) {
    element.title = label;
  } else {
    element.removeAttribute('title');
  }
}
